var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"office-map"},[_c('iframe',{attrs:{"src":_vm.frame_src,"width":"100%","height":"450","title":"Company map location","allowfullscreen":"","loading":"lazy","referrerpolicy":"no-referrer-when-downgrade"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }